import React, { useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import NewsSection from "./NewsSection";

const NewsMain = ({
  news,
  handleNext,
  handlePrev,
  hasMore,
  isFetchingNextPage,
  pageIndex,
  isLoading,
  isError,
  totalFetchedPages,
}) => {
  return (
    <main>
      <Breadcrumb title="News" />
      <NewsSection
        news={news}
        handleNext={handleNext}
        handlePrev={handlePrev}
        hasMore={hasMore}
        isFetchingNextPage={isFetchingNextPage}
        pageIndex={pageIndex}
        totalFetchedPages={totalFetchedPages}
      />
    </main>
  );
};

export default NewsMain;
